<template lang="pug">
  div.item-edit-user-icon-photo.f.fh
    v-icon(v-if="!isUploading"
      size="22px" @click="addPhoto") mdi-autorenew
    v-progress-circular(v-else size="18" width="3" indeterminate)
</template>

<style scoped lang="scss">
@import "@/scss/_variables.scss";

.item-edit-user-icon-photo {
  transform: rotate(45deg);
}
</style>

<script>
import { storage } from '@/components/utils/firebase'
import { Camera, CameraSource, CameraResultType } from '@capacitor/camera'

export default {
  data () {
    return {
      takenPhoto: null,
      isUploading: false
    }
  },
  props: {
    uid: {
      type: String,
      required: true
    }
  },
  methods: {
    async addPhoto () {
      this.takenPhoto = await Camera.getPhoto({
        quality: 90,
        allowEditing: false,
        resultType: CameraResultType.DataUrl,
        source: CameraSource.Prompt,
        webUseInput: true,
        saveToGallery: true
      })

      this.isUploading = true

      const base64 = this.takenPhoto.dataUrl
      this.resizeImage(base64, this.uploadImg)
    },
    getUniqueStr (myStrong) {
      let strong = 1000
      if (myStrong) strong = myStrong
      return new Date().getTime().toString(16)  + Math.floor(strong * Math.random()).toString(16)
    },
    resizeImage (base64image, callback) {
      let image = new Image()
      image.crossOrigin = 'Anonymous'
      image.onload = function () {
        const canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')

        const THUMBNAIL_WIDTH = 1000
        const THUMBNAIL_HEIGHT = 1000

        let width, height, ratio
        if (image.width > image.height) {
          // 横長の画像は横のサイズを指定値にあわせる
          ratio = image.height / image.width
          width = THUMBNAIL_WIDTH
          height = THUMBNAIL_WIDTH * ratio
        } else {
          // 縦長の画像は縦のサイズを指定値にあわせる
          ratio = image.width / image.height
          width = THUMBNAIL_HEIGHT * ratio
          height = THUMBNAIL_HEIGHT
        }
        canvas.setAttribute('width', width)
        canvas.setAttribute('height', height)

        ctx.clearRect(0, 0, width, height)
        ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, width, height)
        
        callback(canvas.toDataURL())
      }
      image.src = base64image
    },
    async uploadImg (base64) {
      const fileId = this.getUniqueStr()
      let storageRef = storage.ref()
      const imgRef = storageRef.child(`USER/${this.uid}/ICON/${fileId}.${this.takenPhoto.format}`)
      const imgURL = await imgRef.putString(base64.split(',')[1], 'base64').then(async (snapshot) => {
        var url = await snapshot.ref.getDownloadURL().then(async (downloadURL) => {
          return downloadURL
        })
        return url
      })
      console.log('updateImg', imgURL)
      this.$emit('updateImg', imgURL)
      this.isUploading = false
    }
  }
}
</script>